export default __webpack_public_path__ + "static/media/layout-grid.23f58b52.svg";